export const CALENDLY_URL = 'https://calendly.com/dataaviator/data-aviator-30-minute-demo-meeting';
export const CONTACT_EMAIL = 'doug@data-aviator.com';
export const INFO_EMAIL = 'info@data-aviator.com';
